import { RoleEnum } from '@zeus/index'
import { useTranslation } from 'react-i18next'
import { Outlet, useMatches } from 'react-router-dom'
import SkipLink, { MAIN_ID } from '~/components/SkipLink'
import { Separator } from '~/components/ui/separator'
import { SidebarInset, SidebarProvider, SidebarTrigger } from '~/components/ui/sidebar'
import { useAuth } from '~/helpers/store/auth'
import CapacityAlertBanner from '~/pages/backoffice/admin/billing/CapacityAlertBanner'
import PaymentFailedBanner from '~/pages/backoffice/admin/billing/PaymentFailedBanner'
import { AppSidebar } from '~/pages/backoffice/sidebar/AppSidebar'
import Footer from '~/pages/components/Footer'
import HelpButton from '~/pages/help/components/HelpButton'
import { screenTitleForRole, screenTitleKey } from '~/routes/route-handle'

function BackOfficeLayout() {
  const { t } = useTranslation()
  const { payload } = useAuth()
  // Même titre que l'onglet (`RouteAnnouncer`) : une seule résolution, par la route.
  const screenKey = screenTitleForRole(screenTitleKey(useMatches()), payload?.role)

  return (
    <SidebarProvider>
      <SkipLink />
      <div className="flex h-dvh w-full overflow-hidden">
        <AppSidebar />
        <SidebarInset className="justify-between overflow-hidden">
          <main id={MAIN_ID} tabIndex={-1} className="flex flex-col gap-4 overflow-y-auto p-5 focus:outline-none">
            <div className="flex items-center gap-3">
              <SidebarTrigger />
              <Separator orientation="vertical" className="h-6" />
              <h1 className="font-heading text-2xl font-bold tracking-tight">
                {t(screenKey ?? 'common.back-office')}
              </h1>
              <HelpButton helpPath="/back-office/help" anchor="backoffice.help" className="ml-auto" />
            </div>
            {/* Palier dépassé (#355), paiement en échec (#354) : l'admin seul peut agir. */}
            {payload?.role === RoleEnum.Admin && <PaymentFailedBanner />}
            {payload?.role === RoleEnum.Admin && <CapacityAlertBanner />}
            <Outlet />
          </main>
          <Footer />
        </SidebarInset>
      </div>
    </SidebarProvider>
  )
}

export default BackOfficeLayout
